import LandingPage from '../components/common/LandingPage';

export default function Home() {
  return <LandingPage />;
}